import { render, staticRenderFns } from "./CartScreen.vue?vue&type=template&id=5b9aa801&scoped=true&"
import script from "./CartScreen.vue?vue&type=script&lang=js&"
export * from "./CartScreen.vue?vue&type=script&lang=js&"
import style0 from "./CartScreen.vue?vue&type=style&index=0&id=5b9aa801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9aa801",
  null
  
)

export default component.exports